import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPathways } from '@pathways/redux/pathways/actions';
import { selectPathway } from '@pathways/redux/pathways/reducers';
import Card from './Card';
import './style.less';

function PathwayDetails({ pathwayData, pathwayId, ...props }) {
  const dispatch = useDispatch();
  const [loading, pathway] = useSelector(state => selectPathway(state, pathwayId));

  useEffect(() => {
    dispatch(fetchPathways());
  }, [dispatch]);

  return <Card loading={loading} pathway={pathway} {...props} />;
}

export default PathwayDetails;
